import React, { Component } from 'react'

/**
 * Espelha uma barra de rolagem horizontal acima do conteúdo (além da de baixo).
 * Útil em tabelas largas (MDBDataTable responsive).
 */
class DualHorizontalScroll extends Component {
  constructor(props) {
    super(props)
    this.topRef = React.createRef()
    this.bottomRef = React.createRef()
    this.spacerRef = React.createRef()
    this._syncing = false
    this.state = { contentWidth: 0 }
  }

  componentDidMount() {
    this.updateWidth()
    this._ro = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(() => this.updateWidth())
      : null
    if (this._ro && this.bottomRef.current) {
      this._ro.observe(this.bottomRef.current)
      const table = this.bottomRef.current.querySelector('table')
      if (table) this._ro.observe(table)
    }
    window.addEventListener('resize', this.updateWidth)
  }

  componentDidUpdate() {
    this.updateWidth()
  }

  componentWillUnmount() {
    if (this._ro) this._ro.disconnect()
    window.removeEventListener('resize', this.updateWidth)
  }

  updateWidth = () => {
    const bottom = this.bottomRef.current
    if (!bottom) return
    const table = bottom.querySelector('table') || bottom.firstElementChild
    const width = Math.max(
      bottom.scrollWidth,
      table ? table.scrollWidth : 0,
      bottom.clientWidth,
    )
    if (width !== this.state.contentWidth) {
      this.setState({ contentWidth: width })
    }
  }

  onTopScroll = () => {
    if (this._syncing) return
    this._syncing = true
    if (this.bottomRef.current && this.topRef.current) {
      this.bottomRef.current.scrollLeft = this.topRef.current.scrollLeft
    }
    this._syncing = false
  }

  onBottomScroll = () => {
    if (this._syncing) return
    this._syncing = true
    if (this.topRef.current && this.bottomRef.current) {
      this.topRef.current.scrollLeft = this.bottomRef.current.scrollLeft
    }
    this._syncing = false
  }

  render() {
    const { children, className, style } = this.props
    const { contentWidth } = this.state

    return (
      <div className={className} style={style}>
        <div
          ref={this.topRef}
          onScroll={this.onTopScroll}
          style={{
            overflowX: 'auto',
            overflowY: 'hidden',
            marginBottom: 4,
          }}
        >
          <div
            ref={this.spacerRef}
            style={{
              width: contentWidth || '100%',
              height: 1,
            }}
          />
        </div>
        <div
          ref={this.bottomRef}
          onScroll={this.onBottomScroll}
          style={{
            overflowX: 'auto',
            overflowY: 'visible',
          }}
          className="dual-hscroll-bottom"
        >
          {children}
        </div>
      </div>
    )
  }
}

export default DualHorizontalScroll
